<template>
<div class="product_price">
<b-input-group>
  <template v-slot:append>
    <!--
    <b-input-group-text>
      <b-img @click="increase()" :src="require('@/assets/icons/arrow_small.png')"></b-img>
      <b-img @click="decrease()" style="transform: rotate(180deg); margin-top: 1px;" :src="require('@/assets/icons/arrow_small.png')"></b-img>
    </b-input-group-text>
    -->
  </template>
  <template v-if="listValue" v-slot:prepend>
    <b-input-group-text v-bind:class="{ overriden: isOverriden }">
      {{ listValue }}
    </b-input-group-text>
  </template>
  <b-form-input size="sm"
                type="number"
                :class="{ overriden: isOverriden }"
                v-model.number="localValue"
                :min="0.00"
                :step="0.01"
                ></b-form-input>
  </b-input-group>
</div>
</template>

<script>
export default {
  name: 'ProductPriceControl',
  props: {
    value: {
      type: Number,
      required: true
    },
    listValue: {
      type: Number,
      required: false
    }
  },
  computed: {
    localValue: {
      get () {
        return this.value
      },
      set (localValue) {
        console.log('localValue', localValue)
        this.$emit('input', localValue)
      }
    },
    isOverriden: function () {
      if (this.localValue !== this.listValue) {
        return true
      }
      return false
    }
  },
  methods: {
    increase () {
      this.localValue += 1
    },
    decrease () {
      if ((this.localValue - 1) >= 0) {
        this.localValue -= 1
      }
    }
  }
}
</script>

<style lang="scss">
.product_price {
  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance:textfield;

    &.overriden {
      background-color: green;
      color: black;
    }
  }

  .input-group-append {
    position: absolute;
    z-index: 100;
    right: 5px;
    top: 9px;

    .input-group-text {
      display: flex;
      flex-direction: column;
      border: 0;
      padding: 0;
      background-color: transparent;

      img {
        cursor: pointer;
      }
    }
  }

  .input-group-prepend {
    .input-group-text {
      padding: 0 5px;
      font-size: 0.92rem;

      &.overriden {
        background-color: red;
        color: white;
      }
    }
  }
}
</style>
